import { FieldConfig, FieldRules, FieldRulesConfig } from '@/types/form'

export interface OrderNoteFormState {
  content: string
  status: 'active' | 'inactive'
}

export const orderNoteFields: (keyof OrderNoteFormState)[] = ['content', 'status']

interface OrderNoteFieldsConfig extends FieldConfig<{
  content: FieldRules<OrderNoteFormState['content']>
  status: FieldRules<OrderNoteFormState['status']>
}> {}

interface OrderNoteFieldsConfigProps extends FieldRulesConfig<OrderNoteFormState> {}

export function orderNoteFieldsConfig(_props: OrderNoteFieldsConfigProps): OrderNoteFieldsConfig {
  return {
    fields: {
      content: {
        rules: {
          required: 'Note content is required',
        },
      },
      status: {
        rules: {
          required: 'Status is required',
        },
      },
    },
  }
}
